module.exports = __webpack_public_path__ + "static/faizan-660b190c12c9c70268323c18d23ee6c5.png";